/* floragram.js */
'use strict';

var FloragramCart={
  addToCart:function(variantId,quantity,btn){
    quantity=parseInt(quantity)||1;
    var orig=btn?btn.textContent:'';
    if(btn){btn.textContent='Adding…';btn.disabled=true;}
    var note='';
    var ni=document.getElementById('product-gift-note')||document.getElementById('gift-note-input');
    if(ni)note=ni.value;
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({id:parseInt(variantId),quantity:quantity,properties:note?{'Gift Message':note}:{}})
    }).then(function(r){return r.json();}).then(function(data){
      if(data.status){alert(data.description||'Error adding to cart.');if(btn){btn.textContent=orig;btn.disabled=false;}return;}
      if(btn){
        btn.textContent='✓ Added!';
        btn.style.background='#2D7A4F';
        setTimeout(function(){btn.textContent=orig;btn.style.background='';btn.disabled=false;},1800);
      }
      FloragramCart.fetchAndUpdateDrawer();
      FloragramCart.openDrawer();
    }).catch(function(err){console.error('Cart:',err);if(btn){btn.textContent=orig;btn.disabled=false;}});
  },
  fetchAndUpdateDrawer:function(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('#cart-count').forEach(function(el){el.textContent=cart.item_count;});
      FloragramCart.buildDrawer(cart);
    }).catch(function(e){console.error(e);});
  },
  buildDrawer:function(cart){
    var body=document.getElementById('cart-drawer-body');
    var footer=document.getElementById('cart-drawer-footer');
    if(!body)return;
    if(cart.item_count===0){
      body.innerHTML='<div class="cart-empty"><div class="cart-empty-icon" aria-hidden="true">🌹</div><p class="cart-empty-title">Your cart is empty</p><p class="cart-empty-sub">Add a beautiful arrangement to get started.</p><a href="/collections/all" class="btn-cta-primary" style="display:inline-flex;margin-top:20px;">Shop Now</a></div>';
      if(footer)footer.style.display='none';
      var gw=document.getElementById('cart-drawer-gift');if(gw)gw.style.display='none';
      return;
    }
    if(footer)footer.style.display='';
    var gw=document.getElementById('cart-drawer-gift');if(gw)gw.style.display='block';
    var threshold=9900,remaining=threshold-cart.total_price;
    var pct=Math.min(100,Math.round(cart.total_price*100/threshold));
    var sh=remaining>0
      ?'<div class="cart-shipping-bar"><p class="cart-shipping-text">Add <strong>'+FloragramCart.money(remaining)+'</strong> more for <strong>free shipping</strong></p><div class="cart-shipping-track"><div class="cart-shipping-fill" style="width:'+pct+'%"></div></div></div>'
      :'<div class="cart-shipping-bar"><p class="cart-shipping-text cart-shipping-achieved">✓ You qualify for <strong>free shipping!</strong></p></div>';
    var items='<div class="cart-items">';
    cart.items.forEach(function(item){
      var img=item.image?'<img src="'+item.image+'" alt="'+item.product_title+'" loading="lazy" width="80" height="80" style="width:100%;height:100%;object-fit:cover">':'';
      var variant=(item.variant_title&&item.variant_title!=='Default Title')?'<div class="cart-item-variant">'+item.variant_title+'</div>':'';
      items+='<div class="cart-item"><div class="cart-item-img">'+img+'</div><div class="cart-item-info"><div class="cart-item-name">'+item.product_title+'</div>'+variant+'<div class="cart-item-price">'+FloragramCart.money(item.final_line_price)+'</div><div class="cart-item-qty"><button class="qty-btn" type="button" aria-label="Decrease quantity" onclick="FloragramCart.updateQuantity(\''+item.key+'\','+(item.quantity-1)+')">&#8722;</button><span class="qty-num">'+item.quantity+'</span><button class="qty-btn" type="button" aria-label="Increase quantity" onclick="FloragramCart.updateQuantity(\''+item.key+'\','+(item.quantity+1)+')">+</button><button class="cart-item-remove" type="button" onclick="FloragramCart.updateQuantity(\''+item.key+'\',0)">Remove</button></div></div></div>';
    });
    items+='</div>';
    var frag=document.createDocumentFragment();
    var tmp=document.createElement('div');
    tmp.innerHTML=sh+items;
    while(tmp.firstChild)frag.appendChild(tmp.firstChild);
    body.innerHTML='';
    body.appendChild(frag);
    var sub=document.getElementById('cart-subtotal');
    if(sub)sub.textContent=FloragramCart.money(cart.total_price);
  },
  money:function(cents){return '$'+(cents/100).toFixed(2)+' CAD';},
  saveNote:function(note){
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:note})});
  },
  updateQuantity:function(key,quantity){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:parseInt(quantity)})})
    .then(function(r){return r.json();})
    .then(function(cart){
      document.querySelectorAll('#cart-count').forEach(function(el){el.textContent=cart.item_count;});
      FloragramCart.buildDrawer(cart);
    }).catch(function(e){console.error(e);});
  },
  checkout:function(){window.location.href='/checkout';},
  openDrawer:function(){
    var d=document.getElementById('cart-drawer'),o=document.getElementById('cart-overlay');
    if(d){d.classList.add('open');d.setAttribute('aria-hidden','false');}
    if(o)o.classList.add('show');
    document.body.style.overflow='hidden';
  },
  closeDrawer:function(){
    var d=document.getElementById('cart-drawer'),o=document.getElementById('cart-overlay');
    if(d){d.classList.remove('open');d.setAttribute('aria-hidden','true');}
    if(o)o.classList.remove('show');
    document.body.style.overflow='';
  },
  bindDrawerEvents:function(){
    var cb=document.getElementById('cart-drawer-close');
    if(cb)cb.onclick=function(){FloragramCart.closeDrawer();};
  }
};

function initCountdown(){
  var ds=window.FLORAGRAM_COUNTDOWN_DATE;
  if(!ds)return;
  var t=new Date(ds);
  if(isNaN(t)||t<=new Date())return;
  function pad(n){return String(n).padStart(2,'0');}
  function update(){
    var diff=Math.max(0,t-new Date());
    var d=Math.floor(diff/86400000),h=Math.floor((diff%86400000)/3600000),
        m=Math.floor((diff%3600000)/60000),s=Math.floor((diff%60000)/1000);
    ['bar-d','cd-d'].forEach(function(id){var e=document.getElementById(id);if(e)e.textContent=pad(d);});
    ['bar-h','cd-h'].forEach(function(id){var e=document.getElementById(id);if(e)e.textContent=pad(h);});
    ['bar-m','cd-m'].forEach(function(id){var e=document.getElementById(id);if(e)e.textContent=pad(m);});
    var cs=document.getElementById('cd-s');if(cs)cs.textContent=pad(s);
  }
  update();setInterval(update,1000);
}

function initMobileMenu(){
  var toggle=document.getElementById('mobile-menu-toggle');
  var closeBtn=document.getElementById('mobile-menu-close');
  var menu=document.getElementById('mobile-menu');
  var overlay=document.getElementById('mobile-overlay');
  function open(){if(menu){menu.classList.add('open');menu.setAttribute('aria-hidden','false');}if(overlay)overlay.classList.add('show');document.body.style.overflow='hidden';if(toggle)toggle.setAttribute('aria-expanded','true');}
  function close2(){if(menu){menu.classList.remove('open');menu.setAttribute('aria-hidden','true');}if(overlay)overlay.classList.remove('show');document.body.style.overflow='';if(toggle)toggle.setAttribute('aria-expanded','false');}
  if(toggle)toggle.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',close2);
  if(overlay)overlay.addEventListener('click',close2);
}

function initCartToggle(){
  var toggle=document.getElementById('cart-toggle');
  var overlay=document.getElementById('cart-overlay');
  if(toggle)toggle.addEventListener('click',function(){FloragramCart.fetchAndUpdateDrawer();FloragramCart.openDrawer();});
  if(overlay)overlay.addEventListener('click',function(){FloragramCart.closeDrawer();});
  FloragramCart.bindDrawerEvents();
}

function initSearch(){
  var toggle=document.getElementById('search-toggle');
  var drawer=document.getElementById('search-drawer');
  var overlay=document.getElementById('search-overlay');
  var closeBtn=document.getElementById('search-close');
  var input=document.getElementById('search-input');
  function openSearch(){
    if(drawer){drawer.classList.add('open');drawer.setAttribute('aria-hidden','false');}
    if(overlay)overlay.classList.add('show');
    document.body.style.overflow='hidden';
    setTimeout(function(){if(input)input.focus();},300);
  }
  function closeSearch(){
    if(drawer){drawer.classList.remove('open');drawer.setAttribute('aria-hidden','true');}
    if(overlay)overlay.classList.remove('show');
    document.body.style.overflow='';
  }
  if(toggle)toggle.addEventListener('click',openSearch);
  if(closeBtn)closeBtn.addEventListener('click',closeSearch);
  if(overlay)overlay.addEventListener('click',closeSearch);
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape')closeSearch();
    if(e.key==='k'&&(e.metaKey||e.ctrlKey)&&drawer&&!drawer.classList.contains('open')){
      e.preventDefault();openSearch();
    }
  });
}

function initStickyBar(){
  var bar=document.getElementById('sticky-bar');
  if(!bar)return;
  var shown=false;
  window.addEventListener('scroll',function(){
    var sc=window.scrollY>500;
    if(sc!==shown){shown=sc;bar.classList.toggle('show',shown);}
  },{passive:true});
}

function initProductGallery(){
  var gallery=document.querySelector('.product-gallery-main');
  document.querySelectorAll('.product-thumb').forEach(function(thumb){
    thumb.addEventListener('click',function(){
      var idx=this.dataset.index;
      document.querySelectorAll('.product-gallery-slide').forEach(function(s){s.classList.remove('active');});
      document.querySelectorAll('.product-thumb').forEach(function(t){t.classList.remove('active');});
      var target=document.querySelector('.product-gallery-slide[data-index="'+idx+'"]');
      if(target)target.classList.add('active');
      this.classList.add('active');
    });
  });
  if(gallery){
    var tX=0,tY=0,dragging=false;
    gallery.addEventListener('touchstart',function(e){tX=e.touches[0].clientX;tY=e.touches[0].clientY;dragging=true;},{passive:true});
    gallery.addEventListener('touchend',function(e){
      if(!dragging)return;dragging=false;
      var dx=e.changedTouches[0].clientX-tX,dy=e.changedTouches[0].clientY-tY;
      if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy)*1.5)return;
      var slides=document.querySelectorAll('.product-gallery-slide');
      var thumbs=document.querySelectorAll('.product-thumb');
      var cur=-1;slides.forEach(function(s,i){if(s.classList.contains('active'))cur=i;});
      if(cur===-1)return;
      var next=dx<0?Math.min(cur+1,slides.length-1):Math.max(cur-1,0);
      if(next===cur)return;
      slides.forEach(function(s){s.classList.remove('active');});
      thumbs.forEach(function(t){t.classList.remove('active');});
      slides[next].classList.add('active');
      if(thumbs[next])thumbs[next].classList.add('active');
    },{passive:true});
  }
}

function initCardSlidersLazy(){
  if(!('IntersectionObserver' in window)){initCardSlidersBasic();return;}
  var seen=new WeakSet();
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting||seen.has(e.target))return;
      seen.add(e.target);mountSlider(e.target);
    });
  },{rootMargin:'200px'});
  document.querySelectorAll('.pc').forEach(function(c){obs.observe(c);});
}
function initCardSlidersBasic(){document.querySelectorAll('.pc').forEach(mountSlider);}

function mountSlider(card){
  var images=card.querySelectorAll('.pc-img');
  var dots=card.querySelectorAll('.pc-dot');
  if(images.length<2)return;
  var idx=0,timer,loaded=false;

  /* Load all lazy images immediately on first touch */
  function loadAll(){
    if(loaded)return;loaded=true;
    images.forEach(function(img){
      if(img.dataset.src){img.src=img.dataset.src;delete img.dataset.src;}
    });
  }

  function goTo(n){
    images.forEach(function(i){i.classList.remove('on');});
    dots.forEach(function(d){d.classList.remove('on');});
    idx=((n%images.length)+images.length)%images.length;
    images[idx].classList.add('on');
    if(dots[idx])dots[idx].classList.add('on');
  }

  function start(){timer=setInterval(function(){goTo(idx+1);},3800);}

  card.addEventListener('mouseenter',function(){loadAll();clearInterval(timer);});
  card.addEventListener('mouseleave',function(){start();});

  dots.forEach(function(dot){
    dot.addEventListener('click',function(ev){
      ev.stopPropagation();clearInterval(timer);
      goTo(parseInt(this.dataset.index));start();
    });
  });

  /* SWIPE — listen on imgwrap, navigate on touchend */
  var wrap=card.querySelector('.pc-imgwrap');
  if(!wrap)return;
  var sx=0,sy=0,swiping=false,swipeMoved=false;

  wrap.addEventListener('touchstart',function(e){
    sx=e.touches[0].clientX;sy=e.touches[0].clientY;
    swiping=true;swipeMoved=false;
    loadAll();clearInterval(timer);
  },{passive:true});

  wrap.addEventListener('touchmove',function(e){
    if(!swiping)return;
    var dx=e.touches[0].clientX-sx,dy=e.touches[0].clientY-sy;
    /* If clearly horizontal, mark as swipe move */
    if(Math.abs(dx)>10&&Math.abs(dx)>Math.abs(dy))swipeMoved=true;
  },{passive:true});

  wrap.addEventListener('touchend',function(e){
    if(!swiping)return;swiping=false;
    var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;
    var isSwipe=Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.2;
    if(isSwipe){
      /* Prevent the tap-through to product link */
      e.preventDefault();
      dx<0?goTo(idx+1):goTo(idx-1);
      start();
    } else {
      /* Tap — navigate to product */
      if(!swipeMoved)window.location.href=card.querySelector('a.pc-name-link')?card.querySelector('a.pc-name-link').href:card.querySelector('a').href;
      start();
    }
  },{passive:false});
}

function initWishlist(){
  document.querySelectorAll('.pc-wish').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.stopPropagation();e.preventDefault();
      var on=this.getAttribute('aria-pressed')==='true';
      this.setAttribute('aria-pressed',String(!on));
      this.textContent=on?'♡':'♥';
      this.style.color=on?'':'#B8405E';
      this.style.background=on?'':'#FEF2F6';
    });
  });
}

function initLightbox(){
  var lb=document.createElement('div');
  lb.id='fl-lightbox';
  lb.style.cssText='display:none;position:fixed;inset:0;z-index:9000;background:rgba(10,8,6,.94);align-items:center;justify-content:center;cursor:zoom-out;padding:20px';
  lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');lb.setAttribute('aria-label','Image lightbox');
  lb.innerHTML='<button id="fl-lb-close" style="position:absolute;top:20px;right:24px;background:none;border:none;color:rgba(255,255,255,.8);font-size:36px;cursor:pointer;" aria-label="Close lightbox">✕</button><img id="fl-lb-img" src="" alt="" style="max-width:92vw;max-height:88vh;object-fit:contain;border-radius:3px;"><button id="fl-lb-prev" style="position:absolute;left:16px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.12);border:none;color:#fff;font-size:28px;width:48px;height:48px;border-radius:50%;cursor:pointer;" aria-label="Previous image">‹</button><button id="fl-lb-next" style="position:absolute;right:16px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.12);border:none;color:#fff;font-size:28px;width:48px;height:48px;border-radius:50%;cursor:pointer;" aria-label="Next image">›</button>';
  document.body.appendChild(lb);
  var lbImg=document.getElementById('fl-lb-img');
  var imgs=[],cur=0;
  function open2(a,i){imgs=a;cur=i;show();lb.style.display='flex';document.body.style.overflow='hidden';}
  function close3(){lb.style.display='none';document.body.style.overflow='';}
  function show(){if(imgs[cur])lbImg.src=imgs[cur];}
  document.getElementById('fl-lb-close').onclick=close3;
  lb.onclick=function(e){if(e.target===lb)close3();};
  document.getElementById('fl-lb-prev').onclick=function(e){e.stopPropagation();cur=(cur-1+imgs.length)%imgs.length;show();};
  document.getElementById('fl-lb-next').onclick=function(e){e.stopPropagation();cur=(cur+1)%imgs.length;show();};
  document.addEventListener('keydown',function(e){
    if(lb.style.display==='none')return;
    if(e.key==='Escape')close3();
    if(e.key==='ArrowLeft'){cur=(cur-1+imgs.length)%imgs.length;show();}
    if(e.key==='ArrowRight'){cur=(cur+1)%imgs.length;show();}
  });
  var lbTX=0,lbTY=0,lbSwiping=false;
  lb.addEventListener('touchstart',function(e){lbTX=e.touches[0].clientX;lbTY=e.touches[0].clientY;lbSwiping=true;},{passive:true});
  lb.addEventListener('touchend',function(e){
    if(!lbSwiping)return;lbSwiping=false;
    var dx=e.changedTouches[0].clientX-lbTX,dy=e.changedTouches[0].clientY-lbTY;
    if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy)*1.5)return;
    dx<0?cur=(cur+1)%imgs.length:cur=(cur-1+imgs.length)%imgs.length;
    show();
  },{passive:true});
  var grid=document.querySelector('.life-grid');
  if(grid){
    var cards=grid.querySelectorAll('.life-card');
    var urls=Array.from(cards).map(function(c){
      var img=c.querySelector('img');
      return img?(img.src.replace(/&width=\d+/,'&width=1600').replace(/width=\d+/,'width=1600')):'';
    }).filter(Boolean);
    cards.forEach(function(card,i){
      card.style.cursor='zoom-in';
      card.setAttribute('role','button');card.setAttribute('tabindex','0');
      card.addEventListener('click',function(){open2(urls,i);});
      card.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' ')open2(urls,i);});
    });
  }
}

function fixBuyItNow(){
  var btn=document.getElementById('buy-now-btn');
  if(!btn)return;
  btn.addEventListener('click',function(e){
    e.preventDefault();
    var atcBtn=document.getElementById('product-atc-btn');
    if(atcBtn){
      var m=(atcBtn.getAttribute('onclick')||'').match(/'(\d+)'/);
      if(m){
        var vid=m[1],qty=parseInt((document.getElementById('qty-input')||{}).value)||1;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(vid),quantity:qty})})
          .then(function(){window.location.href='/checkout';}).catch(function(){window.location.href='/checkout';});
        return;
      }
    }
    window.location.href='/checkout';
  });
}

document.addEventListener('DOMContentLoaded',function(){
  initCountdown();
  initMobileMenu();
  initCartToggle();
  initSearch();
  fixBuyItNow();
  requestAnimationFrame(function(){
    initStickyBar();
    initProductGallery();
    initCardSlidersLazy();
    initWishlist();
    if('requestIdleCallback' in window){
      requestIdleCallback(initLightbox,{timeout:2000});
    } else {
      setTimeout(initLightbox,500);
    }
  });
});
